import {
    GET_SETTING_DELIVERY_FEES,
    SET_SETTING_DELIVERY_FEES,
    DEACTIVATE_SETTING_DELIVERY_FEE,
    GET_DISTRIBUTOR_TARIFFS,
} from "./SettingDeliveryService.actionsTypes";

const initialState = {
    active: [],
    future: [],
    totalCount: 0,
    distributorTariffs: [],
    distributorTotalCount: 0,
};

export default function settingDeliveryService(state = initialState, action) {
    switch (action.type) {
        case GET_SETTING_DELIVERY_FEES: {
            const payload = action.payload?.data || {};
            const list = Array.isArray(payload.tariffs) ? payload.tariffs : [];
            return {
                ...state,
                active: list,
                totalCount: Number(payload.totalCount) || 0,
            };
        }
        case SET_SETTING_DELIVERY_FEES: {
            const payload = action.payload || {};
            const list = Array.isArray(payload.tariffs)
                ? payload.tariffs
                : state.active;
            return {
                ...state,
                active: list,
                totalCount: Number(payload.totalCount) || state.totalCount,
            };
        }
        case DEACTIVATE_SETTING_DELIVERY_FEE: {
            const id = action.payload;
            return {
                ...state,
                active: (state.active || []).filter((item) => item._id !== id),
            };
        }
        case GET_DISTRIBUTOR_TARIFFS: {
            const payload = action.payload?.data || {};
            const list = Array.isArray(payload.distributors) ? payload.distributors : [];
            return {
                ...state,
                distributorTariffs: list,
                distributorTotalCount: Number(payload.total) || 0,
            };
        }
        default:
            return state;
    }
}
